import { api } from '../config/api'

const baseEndpoint = '/krea'

export const getKreaMyResources = ({ pageNumber = 0, pageSize = 6, ...filters }) =>
  api.get(`${baseEndpoint}/Resource`, { params: { pageNumber, pageSize, ...filters, owner: true, locale: '' } })

export const getKreaSchoolsGroupResources = ({ pageNumber = 0, pageSize = 6, ...filters }) =>
  api.get(`${baseEndpoint}/Resource`, { params: { pageNumber, pageSize, ...filters, owner: false, locale: '' } })
